import { render, staticRenderFns } from "./NewLogisticRequest.vue?vue&type=template&id=81c65f26"
import script from "./NewLogisticRequest.vue?vue&type=script&lang=js"
export * from "./NewLogisticRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports